{
  "runInsights": {
    "exceptions": {
      "bucketCount": "{{count}}×",
      "failedCount": "{{count}} portefeuille(s) n'ont pas réussi la validation",
      "skippedCount": "{{count}} portefeuille(s) ignoré(s)",
      "bucketsTitle": "Problèmes de validation courants",
      "examplesTitle": "Exemples",
      "title": "Anomalies"
    },
    "title": "Aperçus de l'exécution",
    "snapshot": {
      "portfolioLine": "{{total}} portefeuilles · {{rebalanced}} rééquilibré(s) · {{failed}} échec(s) · {{skipped}} ignoré(s)",
      "totalSells": "{{value}} ventes",
      "totalBuys": "{{value}} achats",
      "proposedTrades": "{{count}} transactions proposées",
      "auditsReviewed": "{{count}} portefeuilles avec détails d'audit"
    },
    "impact": {
      "title": "Résumé de l'impact",
      "shelteredOnly": "Toutes les activités de vente étaient à l'abri de l'impôt",
      "taxShelteredPct": "{{value}} % des activités de vente sont à l'abri de l'impôt",
      "noteTaxLocation": "Localisation fiscale appliquée dans {{count}} portefeuille(s)",
      "noteLiquidation": "Liquidation complète dans {{count}} portefeuille(s)",
      "noteFx": "Exposition aux devises signalée dans {{count}} portefeuille(s)",
      "noteSwitch": "Opportunités de transfert dans {{count}} portefeuille(s)",
      "noteCovariance": "Allocation plus simple utilisée dans {{count}} portefeuille(s)",
      "noteCashRaise": "Augmentation des liquidités dans {{count}} portefeuille(s)",
      "noteCashDeploy": "Déploiement des liquidités dans {{count}} portefeuille(s)",
      "noteCash": "Liquidités dans {{count}} portefeuille(s)",
      "noteMultiCurrency": "Multi-devises dans {{count}} portefeuille(s)",
      "noteDefault": "{{label}} dans {{count}} portefeuille(s)",
      "taxableSellsLine": "Ventes imposables {{value}} dans {{count}} portefeuille(s)",
      "taxableSellsGainsFallback": "Peut(vent) déclencher des gains en capital",
      "estRealizedGainsLine": "Gains réalisés estimés {{value}} dans {{count}} portefeuille(s)",
      "outcomeStrip": "{{succeeded}} réussi(s) · {{failed}} échec(s) · {{skipped}} ignoré(s)",
      "outcomeStripWithTrades": "{{succeeded}} réussi(s) · {{failed}} échec(s) · {{skipped}} ignoré(s) · {{sells}} ventes · {{buys}} achats",
      "cashEventsTitle": "Liquidités et devises",
      "flagsTitle": "Indicateurs d'exécution",
      "taxTitle": "Impact fiscal",
      "turnoverTitle": "Rotation",
      "metricsTitle": "Impact sur le portefeuille",
      "otherNotesTitle": "Autres indicateurs",
      "turnoverRunCaption": "Rotation typique {{value}} %",
      "tradeMixTitle": "Activité de transaction",
      "tradeMixRaiseCaption": "Fortes ventes · génération de liquidités",
      "tradeMixDeployCaption": "Forts achats · déploiement de liquidités",
      "tradeMixMixedCaption": "Achats et ventes mixtes",
      "tradeMixBuySell": "{{buys}} achats · {{sells}} ventes",
      "estRealizedGainsIncompleteRun": "Impossible d'estimer les gains réalisés pour {{lineCount}} vente(s) dans {{portfolioCount}} portefeuille(s)",
      "estRealizedGainsUnavailableRun": "Impossible d'estimer les gains réalisés pour {{count}} portefeuille(s) avec des ventes imposables",
      "turnoverTypical": "Rotation typique {{value}} %",
      "turnoverDetailed": "Typique {{median}} % · certains portefeuilles jusqu'à {{p90}} %",
      "turnoverRunFootnote": "Part des avoirs vendus et remplacés",
      "turnoverRunP90": "Certains portefeuilles ont atteint {{value}} %",
      "topTaxableSellsTitle": "Ventes imposables",
      "topShelteredSellsTitle": "Ventes à l'abri de l'impôt",
      "topBatchSellsTitle": "Meilleures ventes",
      "topBatchBuysTitle": "Meilleurs achats",
      "tickerGridTickerColumn": "Symbole boursier",
      "tickerGridAmountColumn": "Montant"
    },
    "reviewNext": {
      "title": "Examiner les suivants",
      "subtitle": "Portefeuilles avec les changements proposés les plus importants dans cette exécution.",
      "movement": "Mouvement",
      "flags": "Indicateurs",
      "open": "Ouvrir",
      "viewAll": "Voir tous les portefeuilles",
      "badgeFailed": "Échec",
      "badgeTax": "Fiscalité",
      "badgeHighTurnover": "Rotation élevée",
      "badgeTransfer": "Retrait en attente",
      "filter": {
        "all": "Tous",
        "passed": "Réussis",
        "failed": "Échec",
        "transfer": "Retrait en attente",
        "tax": "Fiscalité",
        "highTurnover": "Rotation élevée",
        "liquidate": "Cession"
      },
      "badgeLiquidate": "Cession"
    },
    "summaryFailed": "{{count}} échec(s)"
  },
  "reports": {
    "filterModelSelected": "{{label}} ({{count}})",
    "filterModelOption": "{{label}} ({{count}})",
    "filterAssetSelected": "{{ticker}} ({{count}})",
    "client": "Client / ménage",
    "portfolio": "Portefeuille",
    "accounts": "Comptes",
    "status": "Statut",
    "trades": "Transactions",
    "scopeType": "Portée",
    "goal": "Objectif",
    "model": "Modèle",
    "marketValue": "Valeur marchande",
    "driftRequired": "Dérive",
    "cashTrigger": "Déclencheur de trésorerie",
    "tradeRequests": "Demandes de transaction",
    "expandedTradeSummary": "{{count}} transactions proposées · {{buys}} achats · {{sells}} ventes",
    "noAuditDetail": "Les détails de la transaction ne sont pas disponibles pour ce portefeuille.",
    "statusPassed": "Réussi",
    "statusFailed": "Échec",
    "viewChanges": "Voir les changements",
    "noImpactFilterMatches": "Aucun portefeuille ne correspond à ce filtre sur la page actuelle.",
    "noFilterMatches": "Aucun portefeuille ne correspond aux filtres actuels.",
    "filterSearchPlaceholder": "Rechercher un portefeuille",
    "filterModelLabel": "Modèle",
    "filterAssetLabel": "Titre",
    "filterModelAll": "Tous les modèles",
    "filterAssetAll": "N'importe quel titre",
    "filterAssetOption": "{{ticker}} · {{count}} portefeuilles",
    "filterClear": "Effacer",
    "filterSummary": "{{count}} portefeuilles correspondants",
    "filterScopeNotice": "Les filtres s'appliquent à {{loaded}} des {{total}} portefeuilles chargés.",
    "filterAssetScopeNotice": "{{shown}} affichés ici · {{total}} portefeuilles ont négocié ce titre lors de l'exécution.",
    "unresolvedPortfolio": "Portefeuille non disponible",
    "unresolvedPortfolioHint": "Nom du client non disponible — les types de compte sont listés dans la colonne Comptes",
    "sleeveCount": "{{count}} compartiments",
    "openDetailAria": "Ouvrir le portefeuille {{name}}"
  },
  "drawer": {
    "atTarget": "✓",
    "selling": "Vente",
    "buying": "Achat",
    "trades": "Transactions proposées",
    "positionsChanged": "Positions modifiées",
    "exitsSummary": "{{count}} sortie(s) : {{tickers}}",
    "entriesSummary": "{{count}} nouvelle(s) position(s) : {{tickers}}",
    "exitChip": "Sortie {{ticker}}",
    "entryChip": "Nouveau {{ticker}}",
    "accountCount": "{{count}} compartiments",
    "holdingChangesTitle": "Modifications des avoirs",
    "expandHint": "Développez les lignes pour voir comment les transactions sont réparties entre les compartiments.",
    "security": "Titre",
    "target": "Cible",
    "before": "Avant",
    "after": "Après",
    "change": "Changement",
    "newPosition": "Nouveau",
    "exitPosition": "Sortie",
    "sellToCashPosition": "Vendre",
    "cashEventWithdrawalTitle": "Retrait en attente",
    "cashEventNoticeBody": "Les ventes proposées génèrent des liquidités au moment de l'exécution — les cibles du modèle s'appliquent toujours à long terme. Les cellules des sous-comptes affichent les montants de vente, et non une sortie permanente à 0 $.",
    "cashEventSellsSummary": "{{count}} vente(s) pour générer des liquidités : {{tickers}}",
    "atTargetLabel": "À la cible",
    "offTarget": "Hors cible",
    "noWeightDiffs": "Aucune modification des avoirs n'a été enregistrée pour ce portefeuille.",
    "validationFailedTitle": "Impossible de rééquilibrer ce portefeuille",
    "validationWarningTitle": "Veuillez examiner avant de continuer",
    "unreliableSnapshotTitle": "Les données sur les avoirs semblent peu fiables",
    "unreliableSnapshotBody": "Cette exécution a enregistré une valeur marchande égale aux liquidités tout en vendant des positions, de sorte que les avoirs avant la transaction ne peuvent pas être affichés avec précision. Ouvrez la page du portefeuille pour examiner les positions réelles.",
    "liquidateTriggerNotice": "Ce portefeuille a fait l'objet d'une liquidation au moment de l'exécution. Examinez les liquidités et l'activité de retrait sur la page du portefeuille.",
    "transferTriggerNotice": "Ce portefeuille avait un retrait en attente au moment de l'exécution. Les ventes proposées peuvent être motivées par cet événement de trésorerie plutôt que par la dérive du modèle.",
    "unresolvedPortfolioNotice": "L'instantané du portefeuille n'est pas disponible pour cette ligne. Les détails de validation ci-dessous proviennent de l'audit de l'optimiseur (rapport {{reportId}}).",
    "reviewPortfolioHint": "Ouvrez la page du portefeuille pour examiner les avoirs, les liquidités et les détails au niveau du compte que l'exécution du rééquilibrage ne peut pas afficher ici.",
    "reviewPortfolioUnresolvedHint": "Cette exécution ne contient que les données d'audit de l'optimiseur pour ce portefeuille. Ouvrez la page du portefeuille pour inspecter directement les avoirs et les positions de trésorerie.",
    "reviewPortfolioOpen": "Ouvrir le portefeuille",
    "modelTargetWeight": "Cible du modèle : {{amount}} des actifs investissables",
    "auditGrid": {
      "proposed": "Proposé",
      "multiCurrencyCashTooltip": "Liquidités actuelles par devise. Le total proposé est dans la devise de base du portefeuille."
    },
    "cashEventLiquidationTitle": "Cession",
    "snapshotNotice": "Les valeurs reflètent le portefeuille au moment de l'exécution."
  },
  "title": "Rééquilibrage en masse",
  "detailTitle": "Exécution du rééquilibrage",
  "listPlaceholder": "L'historique des exécutions et le flux de démarrage de l'exécution apparaîtront ici.",
  "detailPlaceholder": "Le tableau de bord de l'exécution pour {{runId}} apparaîtra ici.",
  "breadcrumbRun": "Exécution {{runId}}",
  "table": {
    "newRun": "Nouvelle exécution de rééquilibrage",
    "createdAt": "Créé le",
    "byCreator": "Par {{name}}",
    "type": "Type de rééquilibrage",
    "status": "Statut",
    "result": "Résultat",
    "empty": "Aucune exécution de rééquilibrage en direct pour le moment. Démarrez une exécution lorsque vous êtes prêt(e) à rééquilibrer les portefeuilles admissibles.",
    "organization": "Organisation",
    "openRunAria": "Ouvrir l'exécution de rééquilibrage de {{when}}, {{type}}"
  },
  "outcome": {
    "rebalanced": "{{count}} rééquilibré(s)",
    "failed": "{{count}} échec(s)",
    "skipped": "{{count}} ignoré(s)",
    "none": "Aucun portefeuille traité",
    "processing": "Traitement des portefeuilles…",
    "processingTotal": "0 portefeuille(s) sur {{total}} traité(s)",
    "processingProgress": "{{processed}} portefeuille(s) sur {{total}} traité(s)"
  },
  "actionHint": {
    "preview": "Aperçu seulement",
    "reviewResults": "Examiner les résultats",
    "running": "En cours",
    "failed": "Échec de l'exécution",
    "review": "Examiner l'exécution"
  },
  "duration": {
    "completedIn": "Terminé en {{value}}"
  },
  "audit": {
    "title": "Résumé de l'audit",
    "portfoliosReviewed": "{{count}} portefeuilles examinés",
    "proposedTrades": "{{count}} transactions proposées",
    "totalBuys": "{{value}} achats",
    "totalSells": "{{value}} ventes",
    "validationIssues": "{{count}} problèmes de validation",
    "portfoliosWithValidationIssues": "{{count}} portefeuille(s) n'ont pas réussi la validation",
    "validationIssuesUnknown": "Examinez les portefeuilles individuels pour les détails de validation.",
    "validationFailedUnknown": "La validation a échoué sans message détaillé.",
    "materialDecisions": "{{count}} ajustement(s) notable(s)",
    "avgSolveTime": "Temps de résolution moyen {{value}}"
  },
  "validationDiagnostics": {
    "account": "Compte",
    "unknownTicker": "Titre inconnu",
    "negativePortfolioCash": "{{value}} liquidités du portefeuille",
    "negativeAccountCash": "{{account}}: {{value}} liquidités",
    "accountMarketValue": "Valeur marchande du compte {{account}}: {{value}}",
    "negativeHoldingQuantity": "{{accountPrefix}}{{ticker}}: {{quantity}} actions ({{value}})",
    "negativeHoldingValue": "{{accountPrefix}}{{ticker}}: position de {{value}}",
    "belowMinimumPortfolioMarketValue": "Valeur marchande du portefeuille {{value}} (inférieure au minimum de 1,00 $)"
  },
  "validationErrors": {
    "nonPositiveMarketValue": "Valeur marchande non viable — souvent causée par des liquidités ou des titres négatifs",
    "negativeQuantity": "Quantité de position négative détectée",
    "noSubAccounts": "Le portefeuille n'a pas de sous-comptes",
    "weightsSumMismatch": "Les pondérations cibles ne totalisent pas correctement",
    "invalidCurrency": "Devise non valide sur un titre",
    "nonPositivePrice": "Prix non positif sur un titre",
    "invalidModelPortfolioType": "Type de portefeuille non pris en charge pour l'optimisation",
    "assetClassTargetsSumMismatch": "Les cibles de catégories d'actifs ne totalisent pas correctement",
    "unknownCode": "Problème de validation: {{code}}"
  },
  "filters": {
    "state": "État",
    "allTypes": "Tous les types",
    "allStates": "Tous les états",
    "clear": "Effacer les filtres",
    "type": "Catégorie"
  },
  "runType": {
    "DRIFT": "Rééquilibrage de dérive",
    "TRANSFER": "Rééquilibrage de trésorerie",
    "ALL_ELIGIBLE": "Rééquilibrage de tous les portefeuilles admissibles"
  },
  "runTypeDescription": {
    "DRIFT": "Rééquilibre les portefeuilles qui ont dévié de leur allocation cible.",
    "TRANSFER": "Rééquilibre les portefeuilles avec des liquidités disponibles ou un déclencheur de trésorerie, comme de nouvelles cotisations ou des retraits en attente.",
    "ALL_ELIGIBLE": "Rééquilibre chaque portefeuille avec un déclencheur actif — liquidités ou événements de trésorerie, besoins de cession, ou dérive au-delà de l'allocation cible."
  },
  "runMode": {
    "DRY_RUN": "Simulation",
    "LIVE": "En direct"
  },
  "runPreset": {
    "V1_COMPATIBLE": "Compatible V1"
  },
  "runState": {
    "INITIATED": "Lancé",
    "OPTIMIZING": "Optimisation en cours",
    "VALIDATING": "Validation en cours",
    "PUBLISHING": "Publication en cours",
    "COMPLETED": "Terminé",
    "FAILED": "Échec"
  },
  "scopeType": {
    "GOAL": "Objectif",
    "SUB_ACCOUNT": "Sous-compte",
    "HOUSEHOLD": "Ménage"
  },
  "insights": {
    "title": "Aperçus du rééquilibrage",
    "summaryTaxableSells": "Ventes imposables {{value}}",
    "summaryShelteredSells": "Ventes à l'abri de l'impôt seulement",
    "changesSectionTitle": "Ce qui change",
    "triggerDrift": "Rééquilibrage de dérive",
    "triggerTransfer": "Retrait en attente",
    "whyRaisingCash": "Générer {{value}} pour financer un retrait",
    "whyDeployingCash": "Déployer une contribution de {{value}}",
    "newPositionsLabel": "Nouvelles positions",
    "soldToRaiseCashLabel": "Vendu pour générer des liquidités",
    "exitedLabel": "Sorti(s)",
    "broughtToTarget": "Rééquilibré {{count}} avoirs pour atteindre la cible",
    "taxSectionTitle": "Impact fiscal et sur les comptes",
    "registeredSells": "Ventes enregistrées : {{value}}",
    "registeredSellsHint": "Aucun gain en capital",
    "taxableSells": "Ventes imposables : {{value}}",
    "taxableSellsHint": "Peut(vent) déclencher des gains",
    "noTaxableSellsHint": "Aucune",
    "registeredSellPct": "{{value}} % de l'activité de vente est à l'abri de l'impôt",
    "shelteredVsTaxable": "{{sheltered}} à l'abri de l'impôt · {{taxable}} imposable",
    "turnoverSectionTitle": "Rotation",
    "situationsSectionTitle": "Considérations supplémentaires",
    "decisionsSectionTitle": "Autres ajustements",
    "liquidationSummary": "{{account}} entièrement liquidé — {{reason}}",
    "liquidationWithdraw": "Transfert de retrait total en attente",
    "liquidationCashTarget": "La cible de liquidités dépasse la valeur du compte",
    "taxLocationApplied": "Localisation fiscale appliquée sur {{subAccountCount}} compartiments et {{holdingCount}} avoirs",
    "taxLocationFlow": "Net ~{{value}} transféré de {{from}} à {{to}}",
    "taxLocationSkipped": "Localisation fiscale non appliquée : {{reason}}",
    "cashRaiseApplied": "Liquidités générées de {{amount}} à partir de {{count}} avoir(s)",
    "cashRaiseAppliedFrom": "Liquidités générées de {{amount}} à partir de {{holding}} dans {{account}}",
    "cashRaiseBlockedMultiCurrency": "Impossible de générer des liquidités — il s'agit d'un compte multidevises",
    "cashDeployApplied": "Liquidités déployées de {{amount}} sur {{count}} avoir(s)",
    "cashDeployAppliedFrom": "Liquidités déployées de {{amount}} vers {{holding}} dans {{account}}",
    "cashDeployBlockedMultiCurrency": "Impossible de déployer des liquidités — il s'agit d'un compte multidevises",
    "multiCurrencyAccount": "Il s'agit d'un compte multidevises",
    "multiCurrencyCashStays": "Les liquidités n'achètent que des avoirs dans la même devise",
    "multiCurrencyCouldNotSeparate": "Impossible de séparer les devises — les transactions peuvent mélanger les devises",
    "multiCurrencyMixedFunding": "Une devise a été financée avec les liquidités d'une autre devise",
    "multiCurrencyNeedsConversion": "Le mélange de devises n'est pas conforme au modèle — nécessite un dépôt, un retrait ou une conversion",
    "decisionStage": {
      "cashRaise": "Génération de liquidités",
      "cashDeploy": "Déploiement de liquidités",
      "cash": "Liquidités",
      "multiCurrency": "Multidevises"
    },
    "taxLocationDegenerate": "Localisation fiscale non nécessaire — tous les avoirs partagent le même rang fiscal",
    "fxExposure": "Exposition au risque de change sur {{holdingCount}} avoir(s) en {{currencies}} (coût estimé d'environ {{bps}} points de base)",
    "switchOpportunitiesPrefix": "Opportunités de transfert :",
    "covarianceFallback": "L'optimisation sensible au risque n'était pas disponible; un modèle d'allocation plus simple a été utilisé",
    "qpFailed": "Échec de l'optimisation : {{reason}}",
    "ai": {
      "generate": "Générer des aperçus",
      "regenerate": "Regénérer",
      "loading": "Rédaction du résumé…",
      "error": "Impossible de générer les aperçus. Veuillez réessayer.",
      "disclaimerTitle": "À propos des aperçus de l'IA",
      "disclaimer": "Ceci est un brouillon généré à partir des chiffres déjà présents sur cette page. Ce n'est pas un conseil. Vérifiez les symboles boursiers, les montants et les notes fiscales par rapport aux aperçus structurés.",
      "generateShort": "Générer des notes",
      "portfolio": {
        "title": "Notes du conseiller"
      },
      "run": {
        "title": "Notes du conseiller"
      },
      "subtitle": "Résumé interprétatif — les métriques structurées ci-dessus font autorité.",
      "betaLabel": "BÊTA"
    },
    "triggerLiquidate": "Cession",
    "estRealizedGainsHint": "Gains réalisés estimés {{value}}",
    "summaryEstRealizedGains": "Gains estimés {{value}}",
    "metricsSectionTitle": "Impact sur le portefeuille",
    "turnoverHoldingCount": "Sur {{count}} avoir(s)",
    "summaryTurnover": "{{value}} % de rotation",
    "triggerScopedCash": "Liquidités par compartiment",
    "scopedCashPreview": "Rééquilibrage des liquidités par compartiment",
    "scopedCashMixedHint": "Exécution de génération et de déploiement sur différents compartiments en une seule passe.",
    "whyDeployedCashOnSleeve": "Déployé {{value}} sur un compartiment",
    "turnoverMeterHeadline": "{{value}} % des avoirs vendus et remplacés",
    "turnoverBuySell": "Achat {{buyPct}} % · Vente {{sellPct}} %",
    "turnoverSummary": "{{turnoverPct}} % des avoirs vendus et remplacés sur {{holdingCount}} avoirs · achat {{buyPct}} %, vente {{sellPct}} %",
    "estRealizedGainsIncompleteLine": "Impossible d'estimer les gains réalisés pour {{count}} vente(s) imposable(s)",
    "estRealizedGainsUnavailable": "Impossible d'estimer les gains réalisés",
    "failureReasonPortfolioCount_one": "{{label}} · 1 portefeuille",
    "failureReasonPortfolioCount_other": "{{label}} · {{count}} portefeuilles",
    "aiHighlightFailedValidation": "Validation échouée",
    "aiHighlightTaxableSells": "Ventes imposables",
    "aiHighlightHighTurnover": "Rotation élevée",
    "aiHighlightTypicalPct": "typique {{value}}%",
    "aiHighlightHighestPct": "le plus élevé {{value}}%"
  },
  "detail": {
    "startedAt": "Débuté le {{value}}",
    "updatedAt": "Mis à jour le {{value}}",
    "outcomeLabel": "Résultat : {{value}}",
    "progressLabel": "Progression de l'exécution",
    "progressStateDescription": {
      "INITIATED": "Démarrage de l'exécution de rééquilibrage…",
      "OPTIMIZING": "Calcul des allocations cibles et des transactions proposées.",
      "VALIDATING": "Vérification des données du portefeuille et des résultats d'optimisation.",
      "PUBLISHING": "Publication des rapports de portefeuilles rééquilibrés."
    },
    "progressProcessedCount": "{{processed}} portefeuille(s) sur {{total}} traité(s)",
    "progressPreviewCount": "{{count}} portefeuille(s) prêt(s) à être prévisualisé(s)",
    "progressPollingNotice": "Les résultats apparaîtront ci-dessous à mesure que chaque portefeuille sera traité.",
    "reportsTitle": "Portefeuilles rééquilibrés",
    "noReports": "Aucun rapport de portefeuille rééquilibré n'a été publié pour cette exécution.",
    "noDryRunReports": "Aucun portefeuille rééquilibré n'a été trouvé pour cette simulation.",
    "inProgressNotice": "Cette exécution est toujours en cours de traitement. Les rapports apparaîtront une fois terminée.",
    "failedNotice": "Cette exécution a échoué avant la publication des rapports de portefeuilles rééquilibrés.",
    "dryRunCompleteNotice": "Les simulations sont uniquement destinées à la prévisualisation. Démarrez une exécution en direct lorsque vous êtes prêt(e) à envoyer les transactions.",
    "zeroSucceededNotice": "Aucun portefeuille n'a été rééquilibré lors de cette exécution. Vérifiez l'admissibilité ou réessayez après avoir résolu les ignorés et les échecs.",
    "proceedToBulkTrader": "Passer au négociateur en bloc",
    "proceedDryRunBlocked": "Les transactions en bloc ne peuvent être générées qu'à partir d'une exécution en direct terminée.",
    "proceedZeroSucceededBlocked": "Il n'y a aucun portefeuille rééquilibré à envoyer au négociateur en bloc.",
    "proceedMissingPermission": "Vous avez besoin de la permission write:bulk_trade_run pour passer au négociateur en bloc."
  },
  "reviewTrades": {
    "title": "Examiner les transactions",
    "openStep": "Examiner les transactions",
    "backToResults": "Retour aux résultats de l'exécution",
    "subtitle": "{{count}} demande(s) de transaction de cette exécution",
    "empty": "Aucune demande de transaction n'a été créée pour cette exécution.",
    "truncated": "Affichage des {{shown}} premières demandes de transaction sur {{total}}.",
    "unverifiedCount": "{{count}} à approuver",
    "unverifiedNotice": "Approuvez les demandes de transaction restantes avant de continuer.",
    "evaluating": "Application des calendriers de transactions…",
    "unknownPortfolio": "Portefeuille inconnu",
    "sharesAll": "Tout",
    "groupTradeCount_one": "{{count}} transaction",
    "groupTradeCount_other": "{{count}} transactions",
    "groupBuy": "acheter {{amount}}",
    "groupSell": "vendre {{amount}}",
    "evaluateError": "Impossible d'appliquer les calendriers de transactions.",
    "cancelError": "Impossible d'annuler les demandes de transaction.",
    "approveError": "Impossible d'approuver les demandes de transaction.",
    "cancelSuccess": "{{count}} demande(s) de transaction annulée(s).",
    "approveSuccess": "{{count}} demande(s) de transaction approuvée(s).",
    "proceedNoTrades": "Il n'y a aucune demande de transaction active à envoyer au négociateur en bloc.",
    "proceedNeedsApproval": "Approuvez les demandes de transaction restantes avant de passer au négociateur en bloc.",
    "proceedWaiting": "Les demandes de transaction sont toujours en cours d'arrivée pour cette exécution.",
    "proceedEvaluating": "Les calendriers de transactions sont toujours en cours d'application.",
    "proceedMissingEvaluatePermission": "Vous avez besoin de la permission write:sub_trade_request pour appliquer les calendriers de transactions.",
    "approveSelected": "Approuver la sélection",
    "cancelSelected": "Annuler la sélection",
    "cancelAll": "Tout annuler",
    "cancelRow": "Annuler",
    "cancelAllTitle": "Annuler toutes les demandes de transaction ?",
    "cancelAllBody": "Ceci annule définitivement toutes les transactions en attente de cette exécution. Elles ne peuvent pas être régénérées à partir de cette page.",
    "cancelAllConfirm": "Annuler toutes les transactions",
    "cancelSelectedTitle": "Annuler les demandes de transaction sélectionnées ?",
    "cancelSelectedBody": "Ceci annule définitivement {{count}} demande(s) de transaction. Elles ne peuvent pas être régénérées à partir de cette page.",
    "cancelRowTitle": "Annuler cette demande de transaction ?",
    "cancelRowBody": "Ceci annule définitivement {{ticker}}. Elle ne peut pas être régénérée à partir de cette page.",
    "cancelRowFallback": "cette demande de transaction",
    "cancelRowConfirm": "Annuler la transaction",
    "cancelConfirm": "Annuler les transactions",
    "keepTrades": "Conserver les transactions",
    "columns": {
      "amount": "Montant",
      "price": "Prix",
      "shares": "Actions",
      "account": "Compte",
      "status": "Statut",
      "note": "Note",
      "type": "Catégorie",
      "security": "Portefeuille / titre",
      "portfolio": "Portefeuille",
      "sleeves": "Compartiments"
    },
    "status": {
      "READY": "Prêt",
      "HELD": "En attente",
      "INITIATED": "En cours",
      "CANCELED": "Annulé",
      "REQUESTED": "Demandé",
      "RECONCILED": "Rapproché",
      "VERIFIED": "Approuvé"
    },
    "holdReason": {
      "schedule": "Prévu le {{date}}",
      "blockedUntil": "Retenu jusqu'au {{date}}",
      "accountInactive": "Compte inactif",
      "subAccountInactive": "Sous-compte inactif"
    },
    "note": {
      "awaitingProceeds": "En attente du produit des ventes",
      "awaitingProceedsTooltip": "Cet achat nécessite des liquidités provenant d'une vente qui sera réglée ultérieurement.",
      "awaitingProceedsWithTickerTooltip": "Nécessite des liquidités de {{ticker}}, qui sera réglé(e) plus tard que cet achat.",
      "pendingWithdraw": "Liquidités réservées pour un retrait",
      "pendingWithdrawTooltip": "Les liquidités disponibles sont retenues pour un retrait en attente, donc cet achat est en attente pour éviter des transactions supplémentaires."
    },
    "type": {
      "BUY": "Achat",
      "SELL": "Vente"
    },
    "readyCount": "{{count}} Prêt(s)",
    "heldCount": "{{count}} Retenu(s)",
    "pendingCount": "{{count}} En attente",
    "canceledCount": "{{count}} Annulé(s)",
    "filterSearchPlaceholder": "Rechercher un client, un portefeuille ou un symbole boursier",
    "filterClear": "Effacer les filtres",
    "filterNoMatches": "Aucune transaction ne correspond aux filtres actuels.",
    "filterResults": "Affichage de {{portfolioCount}} portefeuilles · {{tradeCount}} transactions",
    "expandAll": "Tout développer",
    "collapseAll": "Tout réduire",
    "filterStatus": {
      "all": "Tout",
      "ready": "Prêt",
      "held": "Retenu",
      "pending": "En attente",
      "canceled": "Annulé",
      "needsApproval": "Nécessite une approbation"
    },
    "toggleGroupAria": "Basculer les transactions pour {{name}}",
    "selectAllAria": "Sélectionner toutes les transactions réalisables",
    "selectTradeAria": "Sélectionner la transaction {{ticker}}",
    "settlementBadge": "J+{{days}}",
    "cancelAllFilteredTitle": "Annuler les demandes de transaction correspondantes ?",
    "cancelAllFilteredBody": "Ceci annule définitivement {{count}} demande(s) de transaction en attente correspondant à vos filtres actuels. Les transactions masquées ne sont pas annulées. Elles ne peuvent pas être régénérées à partir de cette page."
  },
  "startRun": {
    "title": "Démarrer l'exécution de rééquilibrage",
    "typeLabel": "Objectif de rééquilibrage",
    "modeLabel": "Mode d'exécution",
    "presetLabel": "Préréglage",
    "presetLockedHelp": "Compatible V1 est le seul préréglage pris en charge pour l'instant.",
    "cancel": "Annuler",
    "confirm": "Démarrer l'exécution",
    "driftToleranceDefaultNote": "Inclut les portefeuilles déjà signalés au-delà de la tolérance de dérive par défaut de {{percent}} %.",
    "changeDriftTolerance": "Changement dans les paramètres de transaction",
    "driftToleranceNote": "Inclut les portefeuilles que le moteur de dérive a déjà signalés par rapport à la propre tolérance de chaque portefeuille."
  },
  "rebalanceMode": {
    "DEPLOY_CASH": "Déployer des liquidités",
    "RAISE_CASH": "Générer des liquidités",
    "FULL_REBALANCE": "Rééquilibrage complet"
  },
  "accountTypeChip": {
    "PERSONAL": "Non enregistré",
    "CORPORATE": "Société"
  }
}
